module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Copyright © 2002 and 2016 by Robb Walsh."), _c('br'), _vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher. "), _c('span', {
    attrs: {
      "href": "#/xhtml/122chapter113#page_292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Page 292")]), _vm._v(" constitutes a continuation of the copyright page.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-4625-6 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-3998-2 (pb)")]), _vm._v(" "), _c('p', [_vm._v("Designed by Erin Mayes and DJ Stout, Pentagram, Austin"), _c('br'), _vm._v("Typesetting by River Jukes-Hudson"), _c('br'), _vm._v("Diagrams by A.J. Garces, with revisions on "), _c('span', {
    attrs: {
      "href": "#/xhtml/103chapter94a#page_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 241")]), _vm._v(" by Amanda Fung")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992f161e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05copyright.vue
// module id = 69
// module chunks = 0